import { render, staticRenderFns } from "./exam_details.vue?vue&type=template&id=7684ae8a&scoped=true&"
import script from "./exam_details.vue?vue&type=script&lang=js&"
export * from "./exam_details.vue?vue&type=script&lang=js&"
import style0 from "./exam_details.vue?vue&type=style&index=0&id=7684ae8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7684ae8a",
  null
  
)

export default component.exports